import { render, staticRenderFns } from "./NewProjectTableTypeList.vue?vue&type=template&id=0445742a&scoped=true&"
import script from "./NewProjectTableTypeList.vue?vue&type=script&lang=js&"
export * from "./NewProjectTableTypeList.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectTableTypeList.vue?vue&type=style&index=0&id=0445742a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445742a",
  null
  
)

export default component.exports